"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCIAL_SOURCES = void 0;
var SOCIAL_SOURCES;
(function (SOCIAL_SOURCES) {
    SOCIAL_SOURCES["YOUTUBE"] = "youtube";
    SOCIAL_SOURCES["TWITTER"] = "twitter";
    SOCIAL_SOURCES["FACEBOOK"] = "facebook";
})(SOCIAL_SOURCES = exports.SOCIAL_SOURCES || (exports.SOCIAL_SOURCES = {}));
//# sourceMappingURL=social-sources.js.map